import { CustomerQueryKeys } from "../Customer/keys";

export const CustomerSsoConfigQueryKeys = {
  all: (customerId: string) => [
    ...CustomerQueryKeys.single(customerId),
    "sso",
  ],
};
